/**
 * Native cart drawer add-ons: shipping protection toggle, free-shipping bar, openNativeCart.
 */
(function () {
  if (window.__SC_CART_ADDONS_INIT__) return;
  window.__SC_CART_ADDONS_INIT__ = true;

  var PROTECTION_PROP = '_shipping_protection';
  var PROTECTION_CHOICE_ATTR = '_sc_protection_choice';
  var _defaultProtectionAttempted = false;
  var _defaultProtectionInFlight = false;

  function emitCartBuild() {
    if (window.SC_emitCartBuild) window.SC_emitCartBuild();
    else document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function emitCartRefresh(cart) {
    if (window.SC_emitCartRefresh) window.SC_emitCartRefresh(cart);
    else {
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      emitCartBuild();
    }
  }

  /** Protection is excluded from [data-products]; toggling must not rebuild the item list. */
  function emitProtectionCartSync(cart) {
    if (cart && cart.items && window.SC_setLastCart) {
      window.SC_setLastCart(cart);
    }
    if (window.SC_emitCartUpdated) {
      window.SC_emitCartUpdated(cart);
      return;
    }
    if (cart && cart.items) {
      document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: cart }
      }));
    }
  }

  function openNativeCart() {
    emitCartBuild();
    if (isStandardStoreHeaderPresent()) {
      document.dispatchEvent(new CustomEvent('cart:open'));
      return;
    }
    ensureLandingCartEnrichment();
    openLandingDrawer();
  }
  window.SC_openNativeCart = openNativeCart;

  function getProtectionEl() {
    return document.querySelector('[data-sc-shipping-protection]');
  }

  function getCheckoutBtn() {
    return document.querySelector('[data-sc-checkout-btn]');
  }

  function getProtectionChoice(cart) {
    if (!cart || !cart.attributes) return null;
    var val = cart.attributes[PROTECTION_CHOICE_ATTR];
    if (val === 'on' || val === 'off') return val;
    return null;
  }

  function persistProtectionChoice(choice) {
    if (!window.theme || !theme.cart || !theme.cart.updateAttribute) {
      return Promise.resolve();
    }
    return theme.cart.updateAttribute(PROTECTION_CHOICE_ATTR, choice).catch(function (err) {
      console.warn('[SC Cart] protection choice attribute failed', err);
    });
  }

  function findProtectionLine(cart, variantId) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.variant_id === variantId) return item;
      if (item.properties && item.properties[PROTECTION_PROP] === 'true') return item;
    }
    return null;
  }

  function isProtectionActive(cart) {
    var wrap = getProtectionEl();
    if (!wrap) return false;

    var variantId = parseInt(wrap.getAttribute('data-variant-id'), 10);
    if (!variantId) return false;

    if (cart && cart.items) {
      return !!findProtectionLine(cart, variantId);
    }

    var toggle = wrap.querySelector('.sc-shipping-protection__toggle');
    return !!(toggle && toggle.checked);
  }

  function updateCheckoutLabel(isProtected) {
    var btn = getCheckoutBtn();
    if (!btn) return;

    var label = btn.querySelector('[data-sc-checkout-label]');

    if (label) {
      label.textContent = isProtected ? 'Protected Checkout' : 'Checkout';
    }

    btn.classList.toggle('cart__checkout--protected', isProtected);
  }

  function syncCheckoutLabelFromCart(cart) {
    updateCheckoutLabel(isProtectionActive(cart));
  }

  function syncProtectionToggleFromCart(cart) {
    var wrap = getProtectionEl();
    if (!wrap || !cart) return;

    var variantId = parseInt(wrap.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    var toggle = wrap.querySelector('.sc-shipping-protection__toggle');
    if (!toggle || wrap.classList.contains('is-busy')) return;

    var inCart = !!findProtectionLine(cart, variantId);
    toggle.checked = inCart;
    wrap.setAttribute('data-in-cart', inCart ? 'true' : 'false');
    updateCheckoutLabel(inCart);
  }

  function addProtection(variantId) {
    var init = {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: { _shipping_protection: 'true' }
        }]
      })
    };
    var fetchFn = window.SC_cartFetch || fetch;
    return fetchFn('/cart/add.js', init).then(function (res) {
      if (!res.ok) return res.text().then(function (t) { throw new Error(t || 'Add protection failed'); });
      return res.json();
    });
  }

  function removeProtection(lineKey) {
    return theme.cart.changeItem(lineKey, 0);
  }

  function handleProtectionToggle(evt) {
    var toggle = evt.target.closest('.sc-shipping-protection__toggle');
    if (!toggle) return;

    var wrap = toggle.closest('[data-sc-shipping-protection]');
    if (!wrap || wrap.classList.contains('is-busy')) return;

    var variantId = parseInt(wrap.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    var desiredOn = toggle.checked;
    var prevChecked = !desiredOn;
    updateCheckoutLabel(desiredOn);
    wrap.setAttribute('data-in-cart', desiredOn ? 'true' : 'false');

    wrap.classList.add('is-busy');

    var choiceVal = desiredOn ? 'on' : 'off';

    persistProtectionChoice(choiceVal).then(function () {
      return theme.cart.getCart();
    }).then(function (cart) {
      var line = findProtectionLine(cart, variantId);
      var op;
      if (desiredOn) {
        op = line ? Promise.resolve(cart) : addProtection(variantId);
      } else {
        op = line ? removeProtection(line.key).then(function (text) {
          try { return JSON.parse(text); } catch (err) { return cart; }
        }) : Promise.resolve(cart);
      }
      return op.then(function (resultCart) {
        var settled = (resultCart && resultCart.items) ? resultCart : cart;
        emitProtectionCartSync(settled);
        syncProtectionToggleFromCart(settled);
      });
    }).catch(function (err) {
      console.error('[SC Cart] protection toggle failed', err);
      toggle.checked = prevChecked;
      wrap.setAttribute('data-in-cart', prevChecked ? 'true' : 'false');
      updateCheckoutLabel(prevChecked);
    }).finally(function () {
      wrap.classList.remove('is-busy');
    });
  }

  function maybeAddDefaultProtection() {
    if (_defaultProtectionAttempted || _defaultProtectionInFlight) return;

    var wrap = getProtectionEl();
    if (!wrap) return;

    var defaultChecked = wrap.getAttribute('data-default-checked') === 'true';
    if (!defaultChecked) return;

    var variantId = parseInt(wrap.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    _defaultProtectionInFlight = true;

    theme.cart.getCart().then(function (cart) {
      if (!cart || !cart.item_count) return;

      var choice = getProtectionChoice(cart);

      if (choice === 'off') {
        syncProtectionToggleFromCart(cart);
        _defaultProtectionAttempted = true;
        return;
      }

      if (choice === 'on') {
        if (findProtectionLine(cart, variantId)) {
          syncProtectionToggleFromCart(cart);
          _defaultProtectionAttempted = true;
          return;
        }
        return addProtection(variantId).then(function (result) {
          _defaultProtectionAttempted = true;
          var settled = (result && result.items) ? result : cart;
          emitProtectionCartSync(settled);
          syncProtectionToggleFromCart(settled);
        });
      }

      if (findProtectionLine(cart, variantId)) {
        syncProtectionToggleFromCart(cart);
        _defaultProtectionAttempted = true;
        return;
      }

      return addProtection(variantId).then(function (result) {
        _defaultProtectionAttempted = true;
        var settled = (result && result.items) ? result : cart;
        emitProtectionCartSync(settled);
        syncProtectionToggleFromCart(settled);
      });
    }).catch(function (err) {
      console.error('[SC Cart] default protection add failed', err);
    }).finally(function () {
      _defaultProtectionInFlight = false;
    });
  }

  function handleCartRefresh(evt) {
    var cart = evt && evt.detail && evt.detail.cart;
    if (cart && cart.items) {
      syncProtectionToggleFromCart(cart);
      return;
    }
    if (!window.SC_getSharedCart && (!window.theme || !theme.cart || !theme.cart.getCart)) return;
    var cartPromise = window.SC_getSharedCart
      ? window.SC_getSharedCart()
      : theme.cart.getCart();
    cartPromise.then(function (c) {
      syncProtectionToggleFromCart(c);
    }).catch(function () {
      updateCheckoutLabel(isProtectionActive());
    });
  }

  function syncCartSavingsFromMarkup() {
    var row = document.querySelector('[data-sc-cart-savings-row]');
    var amountEl = document.querySelector('[data-sc-cart-savings-amount]');
    if (!row || !amountEl) return;

    function hideSavingsRow() {
      row.classList.add('hide');
      amountEl.textContent = '';
    }

    var drawer = document.querySelector('#CartDrawer');
    if (drawer && drawer.classList.contains('is-empty')) {
      hideSavingsRow();
      return;
    }

    var products = document.querySelector('#CartDrawer [data-products]');
    if (!products) {
      hideSavingsRow();
      return;
    }

    var items = products.querySelector('.cart__items');
    if (!items) {
      hideSavingsRow();
      return;
    }

    var count = parseInt(items.getAttribute('data-count') || '0', 10);
    var savings = parseInt(items.getAttribute('data-cart-savings') || '0', 10);
    var formatted = items.getAttribute('data-cart-savings-formatted') || '';

    if (count <= 0 || savings <= 0) {
      hideSavingsRow();
      return;
    }

    row.classList.remove('hide');
    if (formatted) {
      amountEl.textContent = formatted;
    } else if (window.theme && theme.Currency) {
      amountEl.textContent = '-' + theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
    }
  }

  document.addEventListener('cart:open', function () {
    _defaultProtectionAttempted = false;
  });

  document.addEventListener('change', handleProtectionToggle);
  document.addEventListener('cart:updated', function (evt) {
    handleCartRefresh(evt);
    if (window.requestIdleCallback) {
      window.requestIdleCallback(syncCartSavingsFromMarkup, { timeout: 500 });
    } else {
      setTimeout(syncCartSavingsFromMarkup, 350);
    }
  });
  document.addEventListener('cart:build', function () {
    setTimeout(function () {
      maybeAddDefaultProtection();
      handleCartRefresh();
      if (window.requestIdleCallback) {
        window.requestIdleCallback(syncCartSavingsFromMarkup, { timeout: 500 });
      } else {
        syncCartSavingsFromMarkup();
      }
    }, 120);
  });
  document.addEventListener('ajaxProduct:added', function () {
    setTimeout(maybeAddDefaultProtection, 100);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleCartRefresh);
  } else {
    handleCartRefresh();
  }

  // ── FIX 14: Route all off-PDP / plain POST add-to-cart through drawer AJAX ──
  var _drawerAtcLock = false;

  function isCartPageTemplate() {
    return document.body.classList.contains('template-cart');
  }

  function isDrawerCartEnabled() {
    return window.theme && theme.settings && theme.settings.cartType === 'drawer';
  }

  var _landingDrawers = null;
  var _landingCartEnriched = false;

  function isStandardStoreHeaderPresent() {
    return !!document.querySelector('#HeaderWrapper');
  }

  function patchLandingDrawerBodyClassSync(drawers) {
    if (!drawers || drawers.__scBodyClassPatched) return;
    drawers.__scBodyClassPatched = true;

    var origOpen = drawers.open.bind(drawers);
    var origClose = drawers.close.bind(drawers);

    drawers.open = function (evt, returnFocusEl) {
      origOpen(evt, returnFocusEl);
      document.body.classList.add('js-drawer-open');
    };

    drawers.close = function (evt) {
      origClose(evt);
      document.body.classList.remove('js-drawer-open');
    };
  }

  function ensureLandingDrawers() {
    if (_landingDrawers) return _landingDrawers;
    if (!isDrawerCartEnabled()) return null;
    if (isCartPageTemplate()) return null;
    if (!document.querySelector('#CartDrawer')) return null;
    if (isStandardStoreHeaderPresent()) return null;
    if (typeof theme === 'undefined' || typeof theme.Drawers !== 'function') return null;

    _landingDrawers = new theme.Drawers('CartDrawer', 'cart');
    patchLandingDrawerBodyClassSync(_landingDrawers);
    return _landingDrawers;
  }

  function openLandingDrawer(focusEl) {
    var drawers = ensureLandingDrawers();
    if (drawers && typeof drawers.open === 'function') {
      drawers.open(null, focusEl || null);
      return true;
    }
    return false;
  }

  function closeLandingDrawer() {
    if (_landingDrawers && typeof _landingDrawers.close === 'function') {
      _landingDrawers.close();
    }
  }

  function ensureLandingCartEnrichment() {
    if (_landingCartEnriched) return;
    if (isStandardStoreHeaderPresent()) return;
    if (!document.querySelector('#CartDrawer')) return;

    try {
      if (typeof theme !== 'undefined' && typeof theme.CartDrawer === 'function') {
        var cartDrawer = new theme.CartDrawer();
        _landingDrawers = cartDrawer.drawer || null;
        patchLandingDrawerBodyClassSync(_landingDrawers);
        window.SC_nativeCartDrawer = cartDrawer;
        _landingCartEnriched = true;
        return;
      }
    } catch (err) {
      console.warn('[SC Cart] landing CartDrawer init failed, using Drawers-only fallback', err);
    }

    ensureLandingDrawers();

    var form = document.querySelector('#CartDrawerForm');
    if (!form || typeof theme === 'undefined' || typeof theme.CartForm !== 'function') {
      _landingCartEnriched = true;
      return;
    }

    try {
      var cartForm = new theme.CartForm(form);
      if (cartForm && typeof cartForm.buildCart === 'function') {
        cartForm.buildCart();
      }

      document.addEventListener('ajaxProduct:added', function () {
        if (cartForm && typeof cartForm.buildCart === 'function') {
          cartForm.buildCart();
        }
        openLandingDrawer();
      });

      document.addEventListener('cart:open', function () {
        openLandingDrawer();
      });

      document.addEventListener('cart:close', function () {
        closeLandingDrawer();
      });

      window.SC_nativeCartDrawer = {
        open: openLandingDrawer,
        close: closeLandingDrawer
      };
    } catch (err) {
      console.warn('[SC Cart] landing cart enrichment failed', err);
    }

    _landingCartEnriched = true;
  }

  function bootLandingCart() {
    if (isStandardStoreHeaderPresent()) return;
    ensureLandingCartEnrichment();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootLandingCart);
  } else {
    bootLandingCart();
  }

  function shouldBypassDrawerAtc(form) {
    if (!form || !isDrawerCartEnabled()) return true;
    if (isCartPageTemplate()) return true;
    if (form.classList.contains('product-single__form')) return true;
    if (form.closest('.modal--quick-shop, .quick-shop-modal')) return true;
    if (form.id === 'CartDrawerForm') return true;
    return false;
  }

  function getAtcButton(form) {
    return form.querySelector(
      '[type="submit"][name="add"], .product-form__cart-submit, .btn--add-to-cart, ' +
      '[data-add-to-cart], .sc-cgrid-card__atc, .product-card__button, .product-slider__button'
    );
  }

  function clearFormErrors(form) {
    var errors = form.querySelector('.errors');
    if (errors) errors.remove();
  }

  function showFormError(form, message) {
    clearFormErrors(form);
    var errorDiv = document.createElement('div');
    errorDiv.className = 'errors text-center';
    errorDiv.textContent = message;
    form.appendChild(errorDiv);
  }

  function buildCartAddPayload(form) {
    var fd = new FormData(form);
    var id = fd.get('id');
    if (!id) return null;

    var qty = parseInt(fd.get('quantity'), 10);
    if (!qty || qty < 1) qty = 1;

    var item = { id: parseInt(id, 10), quantity: qty };

    var sellingPlan = fd.get('selling_plan');
    if (sellingPlan && String(sellingPlan).trim() && String(sellingPlan) !== '0') {
      item.selling_plan = String(sellingPlan).trim();
    }

    var properties = {};
    fd.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (!match || value == null) return;
      var str = String(value).trim();
      if (!str) return;
      properties[match[1]] = str;
    });
    if (Object.keys(properties).length) item.properties = properties;

    return { items: [item] };
  }

  function seedGiftPairingsFromForm(form) {
    if (typeof window.SC_seedFreeGiftPairings === 'function') {
      window.SC_seedFreeGiftPairings();
    }
    if (form && form.getAttribute && form.getAttribute('data-sc-free-gift')) {
      return;
    }
  }

  async function handleDrawerAtc(form, btn, e) {
    if (_drawerAtcLock) {
      e.preventDefault();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      return;
    }
    if (e.defaultPrevented) return;
    if (shouldBypassDrawerAtc(form)) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var payload = buildCartAddPayload(form);
    if (!payload || !payload.items[0].id) {
      showFormError(form, 'Please select a product option');
      return;
    }

    _drawerAtcLock = true;
    if (btn) {
      btn.disabled = true;
      btn.classList.add('btn--loading');
    }
    clearFormErrors(form);
    seedGiftPairingsFromForm(form);

    try {
      var cartAddUrl = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
      var res = await fetch(cartAddUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      });

      var data = await res.json();
      if (!res.ok || data.status === 422) {
        var msg = (data && data.description) || (data && data.message) || 'Unable to add to cart';
        showFormError(form, typeof msg === 'string' ? msg : 'Unable to add to cart');
        return;
      }

      form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        bubbles: true,
        detail: { product: data, addToCartBtn: btn }
      }));
      openNativeCart();
    } catch (err) {
      console.error('[SC Cart] drawer ATC failed', err);
      showFormError(form, 'Unable to add to cart. Please try again.');
    } finally {
      _drawerAtcLock = false;
      if (btn) {
        btn.disabled = false;
        btn.classList.remove('btn--loading');
      }
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var btn = (e.submitter && e.submitter.matches('[type="submit"]')) ? e.submitter : getAtcButton(form);
    handleDrawerAtc(form, btn, e);
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-drawer-open-cart, .site-nav__link--icon.cart-link, .cart-link')) return;
    var btn = e.target.closest(
      '[type="submit"][name="add"], .product-form__cart-submit, .btn--add-to-cart, ' +
      '[data-add-to-cart], .sc-cgrid-card__atc, .product-card__button, .product-slider__button'
    );
    if (!btn || btn.disabled) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;
    handleDrawerAtc(form, btn, e);
  }, true);

  // ── FIX 15: Drawer trash removes via AJAX (never navigate to /cart) ──
  var _removeLock = false;

  function parseLineKeyFromRemoveEl(el) {
    if (!el) return null;
    var key = el.getAttribute('data-line-key');
    if (key) return key;
    var row = el.closest('[data-key]');
    if (row) return row.getAttribute('data-key');
    var href = el.getAttribute('href');
    if (!href) return null;
    try {
      return new URL(href, window.location.origin).searchParams.get('id');
    } catch (err) {
      var match = href.match(/[?&]id=([^&]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    }
  }

  function loadFreeGiftMap() {
    try {
      var raw = localStorage.getItem('sc_free_gift_map');
      var parsed = raw ? JSON.parse(raw) : {};
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  function isFreeGiftLine(item) {
    return !!(item && item.properties && item.properties._seedcube_upsell === 'free_gift');
  }

  function getDrawerRemoveKeys(lineKey, cartItems) {
    if (!lineKey) return [];
    if (!cartItems || !cartItems.length) return [];

    var targetItem = null;
    for (var i = 0; i < cartItems.length; i++) {
      if (cartItems[i].key === lineKey) {
        targetItem = cartItems[i];
        break;
      }
    }
    if (!targetItem) return [];

    var keys = [lineKey];
    var map = loadFreeGiftMap();
    var pairedGiftIds = (map[String(targetItem.variant_id)] || []).map(function (id) {
      return parseInt(id, 10);
    }).filter(Boolean);

    if (pairedGiftIds.length) {
      cartItems.forEach(function (item) {
        if (item.key === lineKey) return;
        if (pairedGiftIds.indexOf(item.variant_id) !== -1) {
          keys.push(item.key);
        }
      });
      return keys;
    }

    if (isFreeGiftLine(targetItem)) return [lineKey];

    return [lineKey];
  }

  function cartHasLineKey(cart, key) {
    if (!key) return false;
    if (window.SC_isValidCart) {
      if (!window.SC_isValidCart(cart)) return false;
    } else if (!cart || !cart.items) {
      return false;
    }
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === key) return true;
    }
    return false;
  }

  function readCartForRemove() {
    if (window.SC_getLastCart && window.SC_isValidCart) {
      var cached = window.SC_getLastCart(10000);
      if (window.SC_isValidCart(cached)) return Promise.resolve(cached);
    }
    if (window.SC_getSharedCart) return window.SC_getSharedCart();
    if (window.theme && theme.cart && theme.cart.getCart) return theme.cart.getCart();
    return Promise.resolve(null);
  }

  function removeDrawerLines(keys) {
    if (!keys || !keys.length) return Promise.resolve(null);

    function removeKeyAt(index, lastCart) {
      if (index >= keys.length) return Promise.resolve(lastCart);

      return readCartForRemove().then(function (cart) {
        var current = (window.SC_isValidCart && window.SC_isValidCart(cart))
          ? cart
          : lastCart;
        var key = keys[index];

        if (!cartHasLineKey(current, key)) {
          return removeKeyAt(index + 1, current);
        }

        var changeFn = window.SC_changeItemSafe;
        if (!changeFn) {
          return Promise.resolve(null);
        }

        return changeFn(key, 0).then(function (result) {
          if (window.SC_isValidCart && window.SC_isValidCart(result)) {
            return removeKeyAt(index + 1, result);
          }
          var recover = window.SC_recoverCartAfterMutation
            ? window.SC_recoverCartAfterMutation()
            : readCartForRemove();
          return recover.then(function (recovered) {
            return removeKeyAt(index + 1, recovered || current);
          });
        });
      });
    }

    return removeKeyAt(0, null);
  }

  function handleDrawerRemoveClick(e) {
    var removeEl = e.target.closest('#CartDrawer .cart__remove-icon, #CartDrawer .cart__remove a, #CartDrawer [data-cart-remove]');
    if (!removeEl) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    if (_removeLock) return;

    var lineKey = parseLineKeyFromRemoveEl(removeEl);
    if (!lineKey || (!window.SC_changeItemSafe && (!window.theme || !theme.cart || !theme.cart.changeItem))) return;

    _removeLock = true;
    removeEl.disabled = true;
    removeEl.classList.add('btn--loading');

    theme.cart.getCart().then(function (cart) {
      var keys = getDrawerRemoveKeys(lineKey, cart && cart.items ? cart.items : []);
      return removeDrawerLines(keys);
    })
      .then(function (cart) {
        if (window.SC_isValidCart && window.SC_isValidCart(cart)) {
          return cart;
        }
        if (window.SC_getLastCart && window.SC_isValidCart) {
          var cached = window.SC_getLastCart(10000);
          if (window.SC_isValidCart(cached)) return cached;
        }
        return theme.cart.getCart();
      })
      .then(function (cart) {
        var parsedCart = cart || {};

        if (parsedCart.status === 422) {
          var msg = parsedCart.message || parsedCart.description || 'Unable to remove item';
          if (typeof window.alert === 'function') window.alert(msg);
          return;
        }

        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: parsedCart }
        }));
        emitCartBuild();
      })
      .catch(function (err) {
        console.error('[SC Cart] remove line failed', err);
      })
      .finally(function () {
        _removeLock = false;
        removeEl.disabled = false;
        removeEl.classList.remove('btn--loading');
      });
  }

  document.addEventListener('click', handleDrawerRemoveClick, true);

  // ── Tidio hide while drawer open (API — Tidio inline styles override CSS) ──
  var tidioReady = false;
  var tidioApi = null;

  function isDrawerOpenForTidio() {
    return document.documentElement.classList.contains('js-drawer-open') ||
      document.body.classList.contains('js-drawer-open');
  }

  function applyTidio(drawerOpen) {
    if (!tidioReady || !tidioApi) return;
    try {
      if (drawerOpen) tidioApi.hide();
      else tidioApi.show();
    } catch (e) {}
  }

  function syncTidioToDrawerState() {
    applyTidio(isDrawerOpenForTidio());
  }

  function initTidioApi(api) {
    var candidate = api || window.tidioChatApi;
    if (!candidate || typeof candidate.hide !== 'function' || typeof candidate.show !== 'function') return;
    tidioApi = candidate;
    tidioReady = true;
    syncTidioToDrawerState();
  }

  function observeDrawerClassForTidio(node) {
    if (!node || node.__scTidioDrawerObserved) return;
    node.__scTidioDrawerObserved = true;
    new MutationObserver(function () {
      syncTidioToDrawerState();
    }).observe(node, { attributes: true, attributeFilter: ['class'] });
  }

  function initTidioDrawerHide() {
    if (window.tidioChatApi) initTidioApi(window.tidioChatApi);

    document.addEventListener('tidioChat-ready', function () {
      initTidioApi(window.tidioChatApi);
    });

    document.addEventListener('drawerOpen.CartDrawer', function () {
      applyTidio(true);
    });

    observeDrawerClassForTidio(document.documentElement);
    observeDrawerClassForTidio(document.body);
    syncTidioToDrawerState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTidioDrawerHide);
  } else {
    initTidioDrawerHide();
  }
})();
